<div class="flex-column gap-S">
	<div class="flex-align-center flex-space-between">
		<div class="font-MM fw-700">{{ 'page.infrastructure.server.networkInterfaces' | translate }}</div>
		<app-button-widget *ngIf="!server.automatic" [disabled]="!isEditor" (onClick)="openDialog()" [tooltip]="'readOnly.buttonTooltip' | translate" [tooltipDisabled]="isEditor" tooltipPosition="left">
			<img *ngIf="isEditor" width="12" src="assets/icons/add.svg" class="filter-primary" alt="">
			<img *ngIf="!isEditor" width="15" src="assets/icons/lock-01.svg">
		</app-button-widget>
	</div>
	<div *ngIf="server" class="flex-column gap-M">
		<div *ngFor="let serverInterface of server.interfaces" class="interface-card">
			<div class="pl-s pr-m pt-s pb-s flex-align-center gap-S">
				<div style="user-select: none; flex: 1" class="flex-align-center gap-S">
					<div class="interface-icon flex-center" style="width: 38px; height: 38px">
						<img src="assets/icons/server-02.svg" width="20" class="filter-grey">
					</div>
					<div class="flex-justify-center flex-column gap-XS" style="width: 130px">
						<div class="text-overflow-ellipsis font-M fw-700">
							{{ serverInterface.serverInterface.ipAddress }}
						</div>
						<div class="text-overflow-ellipsis font-S">
							{{ serverInterface.serverInterface.isPrimary ? ('page.infrastructure.server.mainInterface' | translate) : ('page.infrastructure.server.secondaryInterface' | translate) }}
						</div>
					</div>
				</div>
				<div class="flex-center">
					<app-multi-select [disabled]="!isEditor" class="p-relative" [inputControl]="getControlForInterface(serverInterface.serverInterface.ipAddress)" [confirmButton]="false">
						<div *ngIf="!serverInterface.network && isEditor" class="flex-align-center c-p" select-trigger style="height: 38px;">
							<div class="interface-network flex-center pad-0-S gap-XS no-interface-add">
								<img src="assets/icons/add.svg" width="10" class="filter-primary">
								<span>{{ 'page.infrastructure.server.addConnectedNetwork' | translate }}</span>
							</div>
						</div>
						<app-select-option *ngFor="let network of networkList" [value]="network">
							<span>{{ network.name }}</span>
						</app-select-option>
					</app-multi-select>
					<div *ngIf="serverInterface.network"
						 class="interface-network flex-center pad-0-S gap-XS p-relative" style="cursor: default"
						 [class.interface-network-warning]="!isIpInNetworkRange(serverInterface)"
						 [tooltip]="'page.infrastructure.network.serverNotInRange' | translate"
						 [tooltipDisabled]="isIpInNetworkRange(serverInterface)">
						<img src="assets/icons/network.svg" width="14" [class.filter-warning]="!isIpInNetworkRange(serverInterface)" [class.filter-accent-secondary]="isIpInNetworkRange(serverInterface)" alt=""/>
						<span [class.warning]="!isIpInNetworkRange(serverInterface)">{{ serverInterface.network.name }}</span>
						<div *ngIf="isEditor" style="right: -4px; top: -4px" class="remove-network-button flex-center c-p p-absolute" (click)="removeConnectedNetwork(serverInterface.serverInterface);">
							<img src="assets/icons/close.svg" width="7" class="filter-white">
						</div>
					</div>
				</div>
				<div style="flex: 1" class="flex-align-center interface-menu">
					<div style="margin-left: auto">
						<app-button-widget *ngIf="(!server.automatic || (server.automatic && !serverInterface.serverInterface.isPrimary)) && isEditor" [matMenuTriggerFor]="deleteMenu">
							<img src="assets/icons/dots-vertical.svg" class="filter-primary" alt="">
						</app-button-widget>
						<mat-menu #deleteMenu class="dots-menu"
								  xPosition="before" yPosition="below">
							<div style="padding: 6px;" class="flex-column gap-XS">
								<div *ngIf="!serverInterface.serverInterface.isPrimary" (click)="markInterfaceAsMain(serverInterface.serverInterface);" class="flex-align-center gap-XS b-radius-6 c-p dots-menu-action-button" style="padding: 5px 10px">
									<img src="assets/icons/award-03.svg" width="14" class="filter-white" height="18" alt=""/>
									<div class="font-M fw-500 white">{{ 'page.infrastructure.server.markInterfaceAsMain' | translate }}</div>
								</div>
								<div *ngIf="!server.automatic" (click)="openDialog(serverInterface);" class="flex-align-center gap-XS b-radius-6 c-p dots-menu-action-button" style="padding: 5px 10px">
									<img src="assets/icons/edit.svg" width="14" class="filter-white" height="18" alt=""/>
									<div class="font-M fw-500 white">{{ 'page.infrastructure.server.updateInterface' | translate }}</div>
								</div>
								<div *ngIf="!server.automatic" (click)="deleteInterface(serverInterface.serverInterface);" class="flex-align-center gap-XS b-radius-6 c-p dots-menu-action-button" style="padding: 5px 10px">
									<img src="assets/icons/trash-03.svg" width="14" class="filter-white" height="18" alt=""/>
									<div class="font-M fw-500 white">{{ 'page.infrastructure.server.deleteInterface' | translate }}</div>
								</div>
							</div>
						</mat-menu>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="server.interfaces.length <= 0" class="flex-column flex-center gap-S" style="height: 300px">
			<img src="assets/illustrations/empty-server-interface.svg" alt="">
			<span class="font-M fw-500 grey">{{ 'page.infrastructure.server.noInterfacePlaceholder' | translate }}</span>
		</div>
	</div>
</div>
